import script from "./FewShotManagementView.vue?vue&type=script&setup=true&lang=js"
export * from "./FewShotManagementView.vue?vue&type=script&setup=true&lang=js"

import "./FewShotManagementView.vue?vue&type=style&index=0&id=6a42f3ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a42f3ee"]])

export default __exports__